import { render, staticRenderFns } from "./AgentSelect.vue?vue&type=template&id=1b34569e&lang=pug"
import script from "./AgentSelect.vue?vue&type=script&lang=js"
export * from "./AgentSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Name: require('/home/docker/code/frontend/components/Name.vue').default,Icon: require('/home/docker/code/frontend/components/Icon.vue').default})
